import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { collection, query, where, getDocs, limit } from "firebase/firestore";
import { db } from "../firebase/config";

const CustomPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const q = query(collection(db, "pages"), where("slug", "==", slug), limit(1));
        const snap = await getDocs(q);
        if (snap.empty) { setNotFound(true); }
        else { setPage({ id: snap.docs[0].id, ...snap.docs[0].data() }); }
      } catch (e) { setNotFound(true); }
      setLoading(false);
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="w-10 h-10 border-4 border-[#e84fa5] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (notFound || !page) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
        <p className="text-6xl font-extrabold text-gray-100 mb-4">404</p>
        <h1 className="text-2xl font-extrabold text-gray-800 mb-2">Page Not Found</h1>
        <p className="text-gray-500 mb-6">The page you're looking for doesn't exist.</p>
        <Link to="/" className="px-6 py-3 bg-[#e84fa5] text-white font-bold rounded-lg hover:bg-pink-600 transition">
          Go Home
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen" style={{ fontFamily: "Montserrat, sans-serif" }}>
      {/* Page Header */}
      <div className="bg-[#f8f0f5] py-12 px-6 text-center border-b">
        <h1 className="text-3xl md:text-4xl font-extrabold text-black">{page.title}</h1>
        {page.metaDescription && (
          <p className="text-gray-500 text-sm mt-3 max-w-xl mx-auto">{page.metaDescription}</p>
        )}
      </div>

      {/* Page Content */}
      <div className="max-w-[900px] mx-auto px-6 py-12">
        <div
          className="page-content"
          dangerouslySetInnerHTML={{ __html: page.content || "" }}
        />
      </div>
    </div>
  );
};

export default CustomPage;
